// extracted by mini-css-extract-plugin
export default {"root":"ModalHeader-root-e2af92e197cc3ec598c48389eadb49f2"};